import React, { useRef } from 'react'
import { Body, Box, H3 } from '../layout'
import { post } from '../../utilities'
import { Checkbox, Field, Radio } from '../widgets'

export const PartnerForm = ({ onSubmit }) => {
  const form = useRef()

  const submitForm = e => {
    if(form.current.reportValidity()) {
      const values = Object.fromEntries(new FormData(form.current))
      const formattedValues = {
        additionalInfo: `Interest: Shivoo partner pricing \nYears in operation: ${values.age} \nTypical number of clients: ${values.clients} \nTypical size of clients: ${values.clientSize} \nOther tools previously used? ${values.other} \nCurrently accredited: ${values.accredited === 1 ? 'Yes' : 'No'}`,
        emailType: 'partnerPricing',
        ...values
      }

      post('conferenceContact', formattedValues).then(async res => {
        const bodyStreamRes = await new Response(res.body).text()
        if(res.status === 200 || bodyStreamRes.includes('Contact already exists')) {
          onSubmit?.(values)
        }
      })
    }
    e.preventDefault()
  }

  return (
    <form ref={form}>
      <Box column gap={32} px={24} width={745} maxWidth="100vw">
        <H3 align="left">Unlock exclusive partnership benefits and elevate your experience</H3>
        <Body>Fill out our Partner form below to learn more about our pricing and exclusive features.</Body>

        <Field name="firstname" label="Your first name *" required />
        <Field name="lastname" label="Your last name *" required />
        <Field name="email" label="Email *" type="email" required />
        <Field name="company" label="Company name" />
        <Field name="website" label="Company website" />
        <Field name="country" label="Country" />
        <Field name="age" label="Years in operation" />
        <Field name="clients" label="Typical number of clients" />
        <Field name="clientSize" label="Typical size of clients" />
        <Field name="other" label="What other psychometric assessments, team diagnostics or organisational network analysis tools have you used in the past?" />
        <Radio name="accredited" label="Are you currently accredited through Pod&Hive?" />
        <Checkbox
          name="agree"
          label={<>
            I have read and understood the <a href="/agreement" target="_blank" style={{ textDecoration: 'underline' }}><b><i>Partner Agreement</i></b></a> for Shivoo
          </>}
        />
        <button onClick={submitForm} type="submit">Submit</button>
      </Box>
    </form>
  )
}